import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface I8x8MaskedConfig {
  isApiKeySet: boolean;
  isApiSecretSet: boolean;
  enabled: boolean;
}

export interface I8x8IntegrationBody {
  apiKey?: string;
  apiSecret?: string;
  enabled: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class NoteTaker8x8ApiService {
  private readonly baseUrl = environment.nt8x8ApiUrl;

  constructor(private http: HttpClient) {}

  public getIntegrationConfig(): Observable<I8x8MaskedConfig> {
    return this.http.get<I8x8MaskedConfig>(`${this.baseUrl}/8x8/integration`);
  }

  public putIntegrationConfig(config: I8x8IntegrationBody): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/8x8/integration`, config);
  }
}
